/**
 * The one version that names everything in this package that can change a recommendation.
 *
 * The matrix, its rationale, the points, the size tolerances and the match-level bands move together, so they share a single identifier. It travels with every result, and it is what an order line may one day record as the reason a frame was suggested. frame-rules-v1 is frozen: changing any rule means a new version, never an edit to this one.
 */
export const FRAME_RULES_VERSION = 'frame-rules-v1';
